import { LocalAudioTrackPublication, LocalVideoTrackPublication } from 'twilio-video'
import { TrackState } from './types'

/**
 * Updates the Twilio Track status
 * @param publicationMap A Twilio Audio/Video Track Publication Map
 * @param state The state you want to set the tracks to
 * @param trackSid? If trackSid is passed, the state will only change if the trackSID matches the one passed in
 * @returns was the track's state changed
 */
async function changeTwilioTrackState (publicationMap: Map<string, LocalVideoTrackPublication | LocalAudioTrackPublication>, state: TrackState, trackSid?: string): Promise<boolean> {

  let hasStateChanged = false
  const error = false

  for (const [ , publication ] of publicationMap) {

    if (error) break
    if (trackSid && publication.trackSid !== trackSid) continue

    if (state === TrackState.ENABLE) {

      if (!publication.track.isEnabled) {

        try {

          await publication.track.enable()
          hasStateChanged = true

        }
        catch (e) {}

      }

    }
    else {

      if (publication.track.isEnabled) {

        try {

          await publication.track.disable()
          hasStateChanged = true

        }
        catch (e) {}

      }

    }

  }

  return hasStateChanged

}

export default changeTwilioTrackState
